<p class="cm-list-title">
    {{ $label() }}
</p>
<div class="cm-color-grid">
    @if ($resolvedOptions()) {
        @for (option of $resolvedOptions(); track option.color) {
            <button
                class="cm-color-circle"
                [class.selected]="isSelected(option.color)"
                [attr.aria-label]="option.label"
                [title]="option.label"
                [style.background]="option.hex"
                (click)="onColorToggled(option.color)"
                type="button"
            >
                @if (isSelected(option.color)) {
                    <i class="far fa-check cm-checkmark"></i>
                }
            </button>
        }
    } @else {
        <cm-placeholder></cm-placeholder>
        <cm-placeholder></cm-placeholder>
        <cm-placeholder></cm-placeholder>
        <cm-placeholder></cm-placeholder>
    }
</div>
